import { render } from "./ChainIcon.vue?vue&type=template&id=64e6a6e5&scoped=true"
import script from "./ChainIcon.vue?vue&type=script&lang=js"
export * from "./ChainIcon.vue?vue&type=script&lang=js"

import "./ChainIcon.vue?vue&type=style&index=0&id=64e6a6e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64e6a6e5"

export default script